import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { membershipLens } from "rtr-constants";
import TrustIcon from "images/trust_icon_20.svg";
import CustomerPromiseIcon from "images/customer-promise.svg";
import { HELP } from "routes";

const FitGuarantee = ({ lens = membershipLens.classic, placement }) => {
  const membershipState = useSelector(state => state?.membershipState);
  const membershipStateLoading = useSelector(state => state?.membershipStateLoading);

  const isMemberLens = lens === membershipLens.unlimited || lens === membershipLens.RTRUpdate;
  if (isMemberLens && membershipStateLoading !== false) return null;

  const link = (
    <a href={`${HELP.FIT_GUARANTEE}&placement=${placement}`} className="underline">
      Learn more
    </a>
  );

  let title = null;
  let copy = null;
  let icon = <TrustIcon className="mr-2" />;

  if (lens === membershipLens.classic) {
    title = "No Risk Rentals";
    copy = <>Let us know if items don't fit and we'll send you replacements right away. {link}</>;
  } else if (isMemberLens && (membershipState?.membershipTermNumber ?? 0) < 2) {
    icon = <CustomerPromiseIcon className="mr-2" />;
    title = "Our Customer Promise";
    copy =
      "If items do not fit right in your first 60 days of subscription, you will get free items in your next shipment.";
  } else {
    return null;
  }

  return (
    <div className="flex flex-col py-3 px-4 text-sm rounded-md mt-6 bg-offWhite">
      <div className="flex items-center justify-center mb-1">
        {icon}
        <p className="font-semibold">{title}</p>
      </div>
      <p className="text-center">{copy}</p>
    </div>
  );
};

FitGuarantee.propTypes = {
  lens: PropTypes.string,
  placement: PropTypes.string,
};

export default FitGuarantee;
